const parsePositiveNumber = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return parsed;
};

const idleMinutesEnv = parsePositiveNumber(process.env.REACT_APP_FRONT_OFFICE_IDLE_MINUTES);

export const FRONT_OFFICE_IDLE_MINUTES = idleMinutesEnv ?? 480;
export const FRONT_OFFICE_IDLE_MS = FRONT_OFFICE_IDLE_MINUTES * 60 * 1000;
export const FRONT_OFFICE_IDLE_ENABLED = false;
